import loadable from '@loadable/component';
export const manifest = {
  'SmeTariffs.Provider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsProvider" */
          './provider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./provider");
            }

            return eval('require.resolve')("./provider");
          }

        }, {
          resolveComponent: m => m.Provider
        })
      }
    }
  },
  'SmeTariffs.CellHolder': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsCellHolder";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsCellHolder" */
          './cell-holder'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./cell-holder");
            }

            return eval('require.resolve')("./cell-holder");
          }

        }, {
          resolveComponent: m => m.CellHolder
        })
      }
    }
  },
  'SmeTariffs.Row': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsRow";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsRow" */
          './row'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./row");
            }

            return eval('require.resolve')("./row");
          }

        }, {
          resolveComponent: m => m.Row
        })
      }
    }
  },
  'SmeTariffs.Rows': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTariffsRows";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTariffsRows" */
          './rows'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./rows");
            }

            return eval('require.resolve')("./rows");
          }

        }, {
          resolveComponent: m => m.Rows
        })
      }
    }
  }
};